import { useNavigate, Outlet } from "react-router-dom";
import { AppSidebar } from "./app-sidebar";
import { AppHeader } from "./app-header";
import { BottomNav } from "./bottom-nav";
import { useAuthStore } from "@/stores/auth.store";
import { useLiveData } from "@/lib/queries";

export function AppLayout() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  // Refresh all queries whenever the demo store mutates (adds, orders,
  // reservations, live-sync ticks) — this is what makes the demo feel live.
  useLiveData();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-dvh bg-background">
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <AppSidebar onLogout={handleLogout} />
      <div className="flex min-w-0 flex-1 flex-col">
        <AppHeader />
        <main
          id="main-content"
          tabIndex={-1}
          className="flex-1 pb-20 lg:pb-0"
        >
          <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
